/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Settings_Group_OrganizationInputs */

const cs_nav_settings_group_organization = /** @type {(inputs: Nav_Settings_Group_OrganizationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organizace`)
};

const en_nav_settings_group_organization = /** @type {(inputs: Nav_Settings_Group_OrganizationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organization`)
};

/**
* | output |
* | --- |
* | "Organization" |
*
* @param {Nav_Settings_Group_OrganizationInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const nav_settings_group_organization = /** @type {((inputs?: Nav_Settings_Group_OrganizationInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Settings_Group_OrganizationInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_settings_group_organization(inputs)
	return cs_nav_settings_group_organization(inputs)
});